import { Reveal } from '../components/motion';
import SEO from '../components/SEO';
import { SectionTag, ArrowBtn, PageHero } from '../components/bits';
import { useLead } from '../components/LeadModal';

const CAPABILITIES = [
  'Sector research', 'Technology assessment', 'Cyber-safety audits', 'Digital diagnostics',
  'Data intelligence', 'Enterprise-specific insight', 'Research and development',
];

export default function Research() {
  const { open } = useLead();
  return (
    <div data-testid="research-page">
    <SEO title="Research & Diagnostics" description="Sector research, technology assessment, cyber-safety audits and data intelligence." />
      <PageHero
        ck="research"
        tag="Research & Diagnostics"
        lines={<>Understand Before <span className="font-serif italic font-normal text-electric">You Invest.</span></>}
        intro="The objective is to identify problems, opportunities and capability gaps before recommending an intervention."
      >
        <ArrowBtn onClick={() => open('Research')} variant="primary" testId="research-cta-diagnostic">Request a Diagnostic</ArrowBtn>
      </PageHero>

      <section className="bg-paper py-20 sm:py-28">
        <div className="wrap">
          <SectionTag>01 — What Research & Diagnostics Can Support</SectionTag>
          <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {CAPABILITIES.map((c, i) => (
              <Reveal key={c} delay={i * 0.04} className={`rounded-3xl p-8 ${i === 6 ? 'bg-navy text-white sm:col-span-2 lg:col-span-3' : 'border border-navy/10 bg-white'}`}>
                <span className={`font-mono text-xs ${i === 6 ? 'text-gold/60' : 'text-electric/50'}`}>0{i + 1}</span>
                <h3 className="mt-3 text-lg font-semibold tracking-tight">{c}</h3>
              </Reveal>
            ))}
          </div>
          <Reveal delay={0.1} className="mt-10"><ArrowBtn onClick={() => open('Research')} variant="navy" testId="research-cta-bottom">Request a Diagnostic</ArrowBtn></Reveal>
        </div>
      </section>
    </div>
  );
}
